import { render, staticRenderFns } from "./MenuSettings.vue?vue&type=template&id=7009cfc4&scoped=true&"
import script from "./MenuSettings.vue?vue&type=script&lang=js&"
export * from "./MenuSettings.vue?vue&type=script&lang=js&"
import style0 from "./MenuSettings.vue?vue&type=style&index=0&id=7009cfc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7009cfc4",
  null
  
)

export default component.exports